export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },

  settings: {
    settings: "/settings",
    settings_details: "/settings/details",
  },

   legal_information: {
    legal_information: "/legal_information",
    legal_information_details: "/legal_information/details",
  },
  how_it_work: {
    how_it_work: "/how_it_work",
    how_it_work_details: "/how_it_work/details/:id",
  },

  features: {
    features: "/features",
    features_details: "/features/details",      
  },

  slideshow: {
    slideshow: "/slideshow",
    slideshow_details: "/slideshow/details",      
  },  

  faqs: {
    faqs: "/faqs",
    faqs_details: "/faqs/details",
  },

  contact_info: {
    contact_info: "/contact_info",
    contact_info_deatils: "/contact_info/details",
  },

  services: {
    services: "/services",
    services_details: "/services/details",
  },

  services_image: {
    services_image: "/services_image/:id",
  },
  admins_logs: {
    admins_logs: "/admins_logs",
  },

  messages:{
    messages: "/messages",
  }
  
};
